import React, { useEffect, useState } from "react";

import { CTooltip } from "@coreui/react";
import { AiFillCheckCircle } from "react-icons/ai";
import { IoAttachOutline } from "react-icons/io5";

import checkIcon from "../../../assets/imgs/trail/checkIcon.png";
import RocketBlue from "../../../assets/imgs/trail/RocketBlue.png";
import RocketWhite from "../../../assets/imgs/trail/RocketWhite.png";

import "./style.css";

function SudentView({
  isFirstStep,
  activity,
  position,
  handleCurrencActivatedStep,
  showEvaluation,
  isLastStep,
  userId,
  flagUpdateInfo,
  loadingNavigationStep,
  disable
}) {
  const [completionPercentage, setCompletionPercentage] = useState(null);
  const [finalGrade, setFinalGrade] = useState(null);
  const [shouldShowStep, setShouldShowStep] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showMessageGrade, setShowMessageGrade] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Defina a largura de tela que define um dispositivo móvel
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Verificar o tamanho inicial

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (activity) {
      setCompletionPercentage(null);
      setFinalGrade(null);
      verify();
      if (activity.activity.executions.length) {
        if (activity.activity.executions[0].completion_percentage !== 0) {
          setCompletionPercentage(
            activity.activity.executions[0].completion_percentage
          );
        }
      }

      if (isLastStep) {
        if (activity.activity.items.length) {
          if (activity.activity.items[0].applications.length > 0) {
            setShowMessageGrade(true);
            if (activity.activity?.items[0]?.applications[0]?.final_grade) {
              setFinalGrade(
                activity.activity?.items[0]?.applications[0]?.final_grade
              );
              setShowMessageGrade(false);
            } else {
              // se final_grade for null e o completionPercentage for 100, a nota está nas execuções
              if (Number(completionPercentage) === 100) {
                setFinalGrade(
                  activity?.activity?.executions[0]?.items[0]?.final_grade
                );
                setShowMessageGrade(false);
              }
            }
          } else {
            if (activity.last_application?.final_grade) {
              setFinalGrade(activity.last_application?.final_grade);
              setShowMessageGrade(false);
            }
          }
        }
      }
    }
  }, [activity, showEvaluation, flagUpdateInfo]);

  const verify = () => {
    if (!isLastStep) {
      setShouldShowStep(true);
    } else {
      if (isLastStep && showEvaluation) {
        setShouldShowStep(true);
      } else {
        // IMPORTANTE! Todas as provas ficarão abeertas
        setShouldShowStep(true);
        // A pedido de Bruna. Mas deve ser avaliado novamente
      }
    }
  };

  const handleActivated = () => {
    if (!activity.activated && !disable) {
      handleCurrencActivatedStep(activity, position);
    }
  };

  const hasStepInName = () => {
    if (activity.activity.name.indexOf("Passo") !== -1) {
      return true;
    }
    return false;
  };

  return (
    <>
      {shouldShowStep && (
        <div className="step-layout">
          <div>
            {Number(completionPercentage) === 100 ? (
              <img
                src={checkIcon}
                width={activity.activated ? 26 : 17}
                style={{
                  marginRight: `${activity.activated ? "13px" : "18px"}`,
                  marginLeft: `${activity.activated ? "-5px" : "-1px"}`,
                  marginTop: `${isMobile ? "0px" : "-8px"}`
                }}
              />
            ) : (
              <div
                className={
                  activity.activated
                    ? "edge-dot edge-dot-activated"
                    : "edge-dot"
                }
              ></div>
            )}
          </div>
          <div
            className={`${
              activity.activated ? "step-card step-card-activated" : "step-card"
            } ${disable ? "step-card-disabled" : ""}`}
            onClick={() => {
              handleActivated();
            }}
          >
            <div
              className={
                !isMobile && activity.activated
                  ? "step-card-header step-card-header-activated"
                  : "step-card-header"
              }
              style={
                (isFirstStep || hasStepInName() ? { borderRadius: "8px" } : {},
                isMobile && Number(completionPercentage) === 100
                  ? { backgroundColor: "#bee9c6" }
                  : Number(completionPercentage) > 0 &&
                    isMobile &&
                    Number(completionPercentage) < 100
                  ? { backgroundColor: "#E8E7BE" }
                  : {})
              }
            >
              <div className="truncate">
                <b
                  style={{
                    fontSize: "16px"
                  }}
                  title={`${activity.activity.name}`}
                >
                  {activity.activity.name}
                </b>
              </div>
              <div>
                {finalGrade && isLastStep && isMobile ? (
                  <div>
                    Nota: <b>{String(finalGrade)}</b>
                  </div>
                ) : isLastStep && showMessageGrade && isMobile ? (
                  <div>
                    <CTooltip
                      content="O processamento de notas está passando por uma manutenção"
                      placement="top"
                    >
                      <span>Em processamento</span>
                    </CTooltip>
                  </div>
                ) : (
                  <></>
                )}
                {completionPercentage && (
                  <b className="percentage-trail-step">
                    {!loadingNavigationStep &&
                    (completionPercentage === null ||
                      Number(completionPercentage) === 0)
                      ? ""
                      : `${completionPercentage}%`}
                  </b>
                )}
              </div>
            </div>
            {activity.activity.items.length ? (
              <div
                className={`step-card-footer ${
                  activity.activated && "step-card-footer-activated"
                } py-2`}
              >
                <div className="step-card-contents">
                  <div className="d-flex">
                    {activity.activity.items.map(() => (
                      <div
                        className={`${
                          activity.activated
                            ? "step-container-items-icons-activated ml-1"
                            : "step-container-items-icons ml-1"
                        }`}
                      >
                        <IoAttachOutline size={20} className="m-1" />
                      </div>
                    ))}
                  </div>
                  {finalGrade && isLastStep ? (
                    <div>
                      Nota: <b>{String(finalGrade)}</b>
                    </div>
                  ) : isLastStep && showMessageGrade ? (
                    <div>
                      <CTooltip
                        content="O processamento de notas está passando por uma manutenção"
                        placement="top"
                      >
                        <span>Em processamento</span>
                      </CTooltip>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              !isFirstStep &&
              !hasStepInName() && (
                <div className="step-card-footer">
                  <b>Sem conteúdo</b>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default SudentView;
